import { render, staticRenderFns } from "./adminTrainingQuizTab.vue?vue&type=template&id=014da530&"
import script from "./adminTrainingQuizTab.vue?vue&type=script&lang=js&"
export * from "./adminTrainingQuizTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports